export default __webpack_public_path__ + "static/media/demand.2c019b60.svg";